@if (userProfilePresent) {
  <div class="user-profile-dropdown" #userMenu>
    <button
      motif-button
      color="link"
      aria-label="User profile"
      id="user-profile-trigger"
      (click)="toggleDropdown()"
      [class.open]="showMenu()"
      [title]="fullName">
      <motif-avatar size="small" [userName]="fullName" [description]="fullName" />
      <div class="menu-dropdown-icon">
        <motif-icon [iconFunction]="arrowDownIcon" size="16"></motif-icon>
      </div>
    </button>

    <div aria-labelledby="user-profile-trigger" class="user-profile-dropdown-menu" [class.show]="showMenu()">
      <div id="user-profile-header-wrapper">
        <app-user-info />
      </div>

      <span class="motif-dropdown-horizontal-divider" role="separator"></span>

      <div id="user-profile-theme-switcher">
        <app-theme-switch />
      </div>

      <span class="motif-dropdown-horizontal-divider" role="separator"></span>

      @for (item of dropdownItems; track item.title) {
        <button (click)="item.onClick()" class="motif-dropdown-item">
          <motif-icon
            [iconFunction]="item.icon"
            title="{{ item.title | translate }}"
            size="18px"
            fill="var(--dropdown-menu-item-icon-color)" />
          {{ item.title | translate }}
        </button>
      }
    </div>
  </div>
}
